module.exports = __webpack_public_path__ + "img/positive-logo.dca29a85.svg";